import { combineReducers } from 'redux';
import {
  loading,
  toaster,
  templates,
  drawer,
  docs,
  signatureRequest,
  companies,
  employees,
  user,
  tenants,
} from '../modules';

const appState = combineReducers({
  loading,
  toaster,
  drawer,
});

const resources = combineReducers({
  templates,
  docs,
  signatureRequest,
  companies,
  employees,
  tenants,
});

const reducers = {
  appState,
  resources,
  user,
};

export default combineReducers(reducers);



// WEBPACK FOOTER //
// ./src/store/reducers.js